export type GeographyRegion = {
  name: string;
  countries: string[];
};

export type GeographyContinent = {
  continent: string;
  regions: GeographyRegion[];
};

export const AURA_GEOGRAPHY: GeographyContinent[] = [
  {
    continent: "Africa",
    regions: [
      {
        name: "Northern Africa",
        countries: [
          "Algeria",
          "Egypt",
          "Libya",
          "Morocco",
          "Sudan",
          "Tunisia",
        ],
      },
      {
        name: "Western Africa",
        countries: [
          "Benin",
          "Ghana",
          "Ivory Coast",
          "Mali",
          "Nigeria",
          "Senegal",
        ],
      },
      {
        name: "Eastern Africa",
        countries: [
          "Ethiopia",
          "Kenya",
          "Rwanda",
          "Somalia",
          "Tanzania",
          "Uganda",
        ],
      },
      {
        name: "Central Africa",
        countries: [
          "Cameroon",
          "Chad",
          "Democratic Republic of the Congo",
          "Gabon",
          "Republic of the Congo",
        ],
      },
      {
        name: "Southern Africa",
        countries: [
          "Botswana",
          "Namibia",
          "South Africa",
          "Zambia",
          "Zimbabwe",
        ],
      },
    ],
  },

  {
    continent: "Asia",
    regions: [
      {
        name: "East Asia",
        countries: [
          "China",
          "Japan",
          "Mongolia",
          "North Korea",
          "South Korea",
        ],
      },
      {
        name: "Southeast Asia",
        countries: [
          "Indonesia",
          "Malaysia",
          "Philippines",
          "Singapore",
          "Thailand",
          "Vietnam",
        ],
      },
      {
        name: "South Asia",
        countries: [
          "Bangladesh",
          "India",
          "Nepal",
          "Pakistan",
          "Sri Lanka",
        ],
      },
      {
        name: "Central Asia",
        countries: [
          "Kazakhstan",
          "Kyrgyzstan",
          "Tajikistan",
          "Turkmenistan",
          "Uzbekistan",
        ],
      },
      {
        name: "Western Asia",
        countries: [
          "Armenia",
          "Georgia",
          "Iran",
          "Iraq",
          "Saudi Arabia",
          "Turkey",
          "United Arab Emirates",
        ],
      },
    ],
  },

  {
    continent: "Europe",
    regions: [
      {
        name: "Northern Europe",
        countries: [
          "Denmark",
          "Finland",
          "Ireland",
          "Norway",
          "Sweden",
          "United Kingdom",
        ],
      },
      {
        name: "Western Europe",
        countries: [
          "Austria",
          "Belgium",
          "France",
          "Germany",
          "Netherlands",
          "Switzerland",
        ],
      },
      {
        name: "Eastern Europe",
        countries: [
          "Belarus",
          "Poland",
          "Romania",
          "Russia",
          "Ukraine",
        ],
      },
      {
        name: "Southern Europe",
        countries: [
          "Croatia",
          "Greece",
          "Italy",
          "Portugal",
          "Spain",
        ],
      },
    ],
  },

  {
    continent: "Americas",
    regions: [
      {
        name: "North America",
        countries: [
          "Canada",
          "Mexico",
          "United States",
        ],
      },
      {
        name: "Central America",
        countries: [
          "Costa Rica",
          "El Salvador",
          "Guatemala",
          "Honduras",
          "Panama",
        ],
      },
      {
        name: "Caribbean",
        countries: [
          "Bahamas",
          "Cuba",
          "Dominican Republic",
          "Haiti",
          "Jamaica",
        ],
      },
      {
        name: "South America",
        countries: [
          "Argentina",
          "Brazil",
          "Chile",
          "Colombia",
          "Peru",
          "Venezuela",
        ],
      },
    ],
  },

  {
    continent: "Oceania",
    regions: [
      {
        name: "Australia & New Zealand",
        countries: [
          "Australia",
          "New Zealand",
        ],
      },
      {
        name: "Melanesia",
        countries: [
          "Fiji",
          "Papua New Guinea",
          "Solomon Islands",
          "Vanuatu",
        ],
      },
      {
        name: "Polynesia",
        countries: [
          "Samoa",
          "Tonga",
          "Tuvalu",
        ],
      },
      {
        name: "Micronesia",
        countries: [
          "Kiribati",
          "Marshall Islands",
          "Micronesia",
          "Palau",
        ],
      },
    ],
  },
];